import { render } from "./CreateUpdateModal.vue?vue&type=template&id=657f52ea&scoped=true"
import script from "./CreateUpdateModal.vue?vue&type=script&lang=js"
export * from "./CreateUpdateModal.vue?vue&type=script&lang=js"

import "./CreateUpdateModal.vue?vue&type=style&index=0&id=657f52ea&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-657f52ea"]])

export default __exports__